module.exports = __webpack_public_path__ + "static/media/eau-fraiche.fe18c565.png";